import React from "react";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import TopMessage from "../components/TopMessage";

function SocialStashGuidanceStep({ isLiveDemo, demoStep, showTutorial }) {
    // Only show if:
    // 1. It is a live demo
    // 2. We have an active demo step (0 or 1)
    // 3. The main tutorial is closed (to avoid overlap)
    const shouldShow = isLiveDemo && demoStep !== null && !showTutorial;


    const getConfig = () => {
        if (demoStep === 0) return {
            title: "Welcome to Social Stash!",
            subtitle: "Let's start by analysing insights for one profile."
        };
        if (demoStep === 1) return {
            title: "Great job!",
            subtitle: "We analysed a single profile. Now, let's try Cross-Platform Analytics by selecting 2 profiles."
        };
        return { title: "", subtitle: "" };
    };

    const { title, subtitle } = getConfig();

    return (
        <>
            {/* 🌑 Global Backdrop for Demo Guide */}
            <Backdrop
                sx={{ color: '#fff', zIndex: 1250 }} // Below raised elements (1350/1400), above standard content
                open={shouldShow}
            />

            {/* 🟢 DEMO GUIDANCE MESSAGE */}
            <TopMessage
                visible={shouldShow}
                title={title}
                subtitle={subtitle}
            />
        </>
    );
}

SocialStashGuidanceStep.propTypes = {
    isLiveDemo: PropTypes.bool,
    demoStep: PropTypes.number,
    showTutorial: PropTypes.bool,
};

export default SocialStashGuidanceStep;
